import { Directive, ElementRef, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subject } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';

@Directive({
  selector: '[ipmScrollBackground]'
})

export class ScrollBackgroundDirective implements OnInit, OnDestroy {
  @Input() navbarHeight: number = 120;
  @Input() debounceTime: number = 50;
  @Output() scrollInView = new EventEmitter<boolean>();

  private scrollSubject = new Subject<void>();
  private destroy$ = new Subject<void>();
  private isInView: boolean = false;

  constructor(private elementRef: ElementRef) {}

  ngOnInit(): void {
    // Debounced scroll handling for performance
    this.scrollSubject
      .pipe(
        debounceTime(this.debounceTime),
        takeUntil(this.destroy$)
      )
      .subscribe(() => {
        this.checkScrollPosition();
      });

    // Initial check
    this.checkScrollPosition();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  @HostListener('window:scroll', ['$event'])
  onWindowScroll(): void {
    this.scrollSubject.next();
  }

  private checkScrollPosition(): void {
    const element = this.elementRef.nativeElement;
    const rect = element.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    const isCurrentlyInView = rect.top < windowHeight && rect.bottom > this.navbarHeight;

    if (isCurrentlyInView !== this.isInView) {
      this.isInView = isCurrentlyInView;
      this.scrollInView.emit(this.isInView);
    }
  }
}
